module.exports = __webpack_public_path__ + "static/media/cibraIcon.85425288.svg";